import { ForwardedRef, forwardRef, ReactNode } from "react";

import { BaseInput, BaseInputProps } from "./base";
import { getLabelMessageId } from "./utils";
import { Label } from "../label";

export type TextFieldInputProps = Omit<
  BaseInputProps,
  "onRightButtonClick" | "message"
> & { message?: string | ReactNode };

const TextFieldInputComponent = (
  props: TextFieldInputProps,
  ref: ForwardedRef<HTMLInputElement>,
) => {
  const { mandatory, ...rest } = props;

  return (
    <Label
      text={props.label}
      mandatory={mandatory}
      disabled={props.disabled}
      name={props.id}
      error={!!props.error}
      message={props.message}
      className="flex-1"
      messageId={getLabelMessageId(props)}
    >
      <BaseInput
        {...rest}
        message={typeof props.message === "string" ? props.message : undefined}
        ref={ref}
      />
    </Label>
  );
};

export const TextFieldInput = forwardRef(TextFieldInputComponent);
